"use client";

import React from "react";
import { Heart, Instagram, Leaf, Facebook } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Badge } from "@/components/ui/badge";
export default function Footer() {
  return <section data-section-id="231652" id="fußzeile" className="bg-background text-foreground relative overflow-hidden py-20 px-6 md:px-12 border-t border-border">
      <div className="max-w-7xl mx-auto text-foreground">
        {}
        <div className="mb-16">
          <Link to="/">
            <WvcLogo className="h-24 md:h-32 w-auto object-contain opacity-80 transition-opacity hover:opacity-100" />
          </Link>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-24">
          {}
          <div>
            <h3 className="font-default text-xl font-bold mb-6 uppercase tracking-widest text-foreground">
              Social Media
            </h3>
            <div className="flex gap-6">
              <Link aria-label="Instagram" className="size-14 text-primary group-hover:scale-110 group-hover:text-primary/80 transition-all duration-300 underline cursor-pointer" href="https://www.instagram.com/bodyconceptallendorfbylinda/" newTab>
                <Instagram strokeWidth={1.5} />
              </Link>
              <Link aria-label="Facebook" className="size-14 text-primary group-hover:scale-110 group-hover:text-primary/80 transition-all duration-300 underline cursor-pointer" href="https://www.facebook.com/profile.php?id=61589691624805" newTab>
                <Facebook strokeWidth={1.5} />
              </Link>
            </div>
          </div>

          {}
          <div>
            <h3 className="font-default text-xl font-bold mb-6 uppercase tracking-widest text-foreground">
              Standort
            </h3>
            <address className="not-italic font-default text-sm leading-relaxed text-muted-foreground !font-normal">Bodyconcept Allendorf<br />Schuhmachergasse 20<br />35108 Allendorf (Eder)<br />linda.treutlein@web.de<br />+49 171 3617469<br /><br />Termine Montag - Freitag<br />nach Vereinbarung!</address>
          </div>

          {}
          <div>
            <h3 className="font-default text-xl font-bold mb-6 uppercase tracking-widest text-foreground">
              Rechtliches
            </h3>
            <ul className="flex flex-col gap-4 font-default text-sm text-muted-foreground">
              <li data-index={0}>
                <Link to="/LegalNoticePage" className="hover:text-primary transition-colors">
                  Impressum
                </Link>
              </li>
              <li data-index={1}>
                <Link to="/LegalNoticePage" className="hover:text-primary transition-colors">
                  Datenschutz
                </Link>
              </li>
              
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-xl font-bold mb-6 uppercase tracking-widest text-foreground">
              Anfahrt
            </h3>
            <div className="w-full h-[200px] rounded-lg overflow-hidden border border-border">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2518.444444444!2d8.675133510333333!3d51.0201301276814f13!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b97368d5e89d89%3A0x63346f048590c8a8!2sSchuhmachergasse+20%2C+35108+Allendorf+(Eder)!5e0!3m2!1sde!2sde!4v1687000000000!5m2!1sde!2sde" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Google Maps Standort" />
            </div>
          </div>
        </div>

        {}
        <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
          <p className="font-default text-xs text-muted-foreground opacity-70">
            © {new Date().getFullYear()} Bodyconcept Allendorf by Linda. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>

      {}
      <div className="absolute bottom-6 right-6 md:bottom-12 md:right-12 z-10">
        <Badge variant="secondary" className="rounded-lg px-5 py-3 text-sm md:text-base font-bold uppercase tracking-wider flex items-center gap-2 bg-accent text-accent-foreground hover:bg-accent/90 shadow-sm border border-border">
          <Heart className="size-4 md:size-5 fill-current" />
          Besuchen Sie uns
          <Leaf className="size-4 md:size-5 fill-current" />
        </Badge>
      </div>
    </section>;
}